import React from "react";
import { ArrowRight, Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getIcon } from "../utils/iconResolver";
import data from "../data/retailData.json";

const { palette: P, features: feat } = data;

const RetailFeatures = () => {
  const nav = useNavigate();
  return (
    <section style={{ background: P.white, padding: "clamp(60px, 8vw, 96px) clamp(20px, 4vw, 40px)" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>

        <div style={{ textAlign: "center", marginBottom: "clamp(40px, 6vw, 64px)" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(93,162,162,0.10)", border: "1px solid rgba(93,162,162,0.25)", padding: "8px 18px", borderRadius: 100, marginBottom: 20 }}>
            <Zap style={{ width: 14, height: 14, color: P.teal }} />
            <span style={{ color: P.teal, fontSize: 13, fontWeight: 700, letterSpacing: "0.05em" }}>{feat.badge}</span>
          </div>
          <h2 style={{ fontSize: "clamp(32px, 5vw, 48px)", fontWeight: 900, letterSpacing: "-0.02em", color: P.ink, lineHeight: 1.1, marginBottom: 16 }}>
            {feat.headline.main} <span style={{ color: P.teal }}>{feat.headline.accent}</span>
          </h2>
          <p style={{ fontSize: "clamp(15px, 2vw, 18px)", color: P.muted, maxWidth: 560, margin: "0 auto", lineHeight: 1.7 }}>{feat.description}</p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 260px), 1fr))", gap: 18 }}>
          {feat.items.map((f, i) => (
            <div key={i}
              style={{ background: P.bgWarm, border: `1px solid ${P.border}`, borderRadius: 18, padding: "clamp(20px, 3vw, 28px) clamp(18px, 2.5vw, 24px)", position: "relative", overflow: "hidden", transition: "all 0.3s", cursor: "default" }}
              onMouseEnter={e => {
                e.currentTarget.style.background = P.white;
                e.currentTarget.style.borderColor = "rgba(93,162,162,0.35)";
                e.currentTarget.style.boxShadow = "0 14px 44px rgba(93,162,162,0.11)";
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.querySelector(".acc").style.transform = "scaleX(1)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = P.bgWarm;
                e.currentTarget.style.borderColor = P.border;
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.transform = "none";
                e.currentTarget.querySelector(".acc").style.transform = "scaleX(0)";
              }}>
              <div style={{ width: 50, height: 50, background: "rgba(93,162,162,0.10)", borderRadius: 13, display: "flex", alignItems: "center", justifyContent: "center", color: P.teal, marginBottom: 16 }}>
                {getIcon(f.icon, { style: { width: 22, height: 22 } })}
              </div>
              <div style={{ fontWeight: 800, fontSize: "clamp(14px, 1.6vw, 15px)", color: P.ink, marginBottom: 8, lineHeight: 1.3 }}>{f.title}</div>
              <div style={{ color: P.muted, fontSize: "clamp(12px, 1.4vw, 13.5px)", lineHeight: 1.65 }}>{f.description}</div>
              <div className="acc" style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 3, background: `linear-gradient(to right, ${P.teal}, ${P.tealLight})`, transform: "scaleX(0)", transformOrigin: "left", transition: "transform 0.3s ease" }} />
            </div>
          ))}
        </div>

        {/* Dark CTA */}
        <div style={{ background: P.darkBg, borderRadius: 24, padding: "clamp(40px, 6vw, 58px) clamp(24px, 5vw, 48px)", marginTop: 48, textAlign: "center", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle at 1.5px 1.5px, rgba(255,230,190,0.04) 1px, transparent 0)", backgroundSize: "38px 38px" }} />
          <div style={{ position: "absolute", top: -90, right: -80, width: 340, height: 340, borderRadius: "50%", background: "radial-gradient(circle, rgba(93,162,162,0.14) 0%, transparent 68%)" }} />
          <div style={{ position: "absolute", bottom: -60, left: -60, width: 260, height: 260, borderRadius: "50%", background: "radial-gradient(circle, rgba(200,130,50,0.08) 0%, transparent 68%)" }} />
          <div style={{ position: "relative" }}>
            <h3 style={{ fontSize: "clamp(24px, 4vw, 36px)", fontWeight: 900, color: "white", marginBottom: 14, letterSpacing: "-0.02em" }}>{feat.cta.headline}</h3>
            <p style={{ color: "rgba(255,255,255,0.50)", fontSize: "clamp(14px, 2vw, 17px)", maxWidth: 500, margin: "0 auto 34px", lineHeight: 1.75 }}>{feat.cta.description}</p>
            <button onClick={() => nav("/contact")}
              style={{ background: P.teal, color: "white", border: "none", padding: "clamp(12px, 2vw, 15px) clamp(28px, 4vw, 40px)", borderRadius: 12, fontSize: "clamp(13px, 1.5vw, 15px)", fontWeight: 700, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 10, boxShadow: "0 8px 30px rgba(93,162,162,0.42)", transition: "all 0.25s" }}
              onMouseEnter={e => { e.currentTarget.style.background = P.tealDark; e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 14px 40px rgba(93,162,162,0.55)"; }}
              onMouseLeave={e => { e.currentTarget.style.background = P.teal; e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 8px 30px rgba(93,162,162,0.42)"; }}>
              {feat.cta.button} <ArrowRight style={{ width: 17, height: 17 }} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RetailFeatures;